// i18n area 'common' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.hy-AM.meta.json.
import type { enUS } from './common'

export const hyAM: typeof enUS = {
  nav: {
    home: 'Գլխավոր',
    vms: 'Վիրտուալ մեքենաներ',
    templates: 'Ձևանմուշներ',
    importVms: 'VM-ների ներմուծում',
    containers: 'Կոնտեյներներ',
    containersApps: 'Հավելվածներ',
    containersPods: 'Pod-եր',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI պատկերներ',
    containersOciRegistries: 'OCI ռեգիստրներ',
    containersCtTemplates: 'CT ձևանմուշներ',
    networkServices: 'Ցանցային ծառայություններ',
    firewall: 'Ֆայրվոլ',
    checkpoints: 'Checkpoint-ներ',
    backup: 'Կրկնօրինակում',
    monitoring: 'Մոնիտորինգ',
    cluster: 'Կլաստեր',
    clusterSettings: 'Գլոբալ կարգավորումներ',
    clusterNodes: 'Հանգույցներ',
    clusterDevices: 'USB և PCIe ռեսուրսներ',
    clusterFederation: 'Ֆեդերացիա',
    network: 'Ցանց',
    overlayNetworks: 'Օվերլեյ ցանցեր',
    fabric: 'Ֆաբրիկա',
    ipam: 'IPAM',
    storage: 'Պահոց',
    data: 'Տվյալներ',
    storages: 'Պահոցներ',
    hci: 'Հիպերկոնվերգենցիա',
    ceph: 'Ceph',
    system: 'Համակարգ',
    tasks: 'Առաջադրանքներ',
    events: 'Իրադարձություններ',
    audit: 'Աուդիտ',
    diagnostics: 'Ախտորոշում',
    notifications: 'Ծանուցումներ',
    proximity: 'TVirt Proximity',
    users: 'Օգտատերեր և խմբեր',
    groups: 'Խմբեր',
    mfa: 'MFA',
    realms: 'Ռեալմներ և SSO',
    rbac: 'Դերեր և թույլտվություններ',
    credentials: 'Հավատարմագրեր',
    scopes: 'Սկոուպներ',
    tags: 'Թեգեր',
    explorer: 'Ուսումնասիրել',
    licensing: 'Լիցենզիա',
    information: 'Տեղեկություններ'
  },
  mode: {
    light: 'Բաց',
    dark: 'Մուգ',
    system: 'Համակարգային',
    tooltip: 'Թեմա'
  },
  language: {
    tooltip: 'Լեզու'
  },
  langRegion: {
    europe: 'Եվրոպա',
    northAmerica: 'Հյուսիսային Ամերիկա',
    southAmerica: 'Հարավային Ամերիկա',
    asia: 'Ասիա'
  },
  notFound: {
    title: 'Էջը չի գտնվել',
    body: 'Այս հասցեն TVirt-ի ոչ մի էջի չի համապատասխանում — այն կարող է տեղափոխված լինել թարմացման հետ, կամ հղումը հնացած է։',
    backHome: 'Վերադառնալ գլխավոր էջ'
  },
  scopeBrowser: {
    title: 'Սկոուպներ',
    all: 'Ամբողջ կլաստերը',
    noChildren: 'Այստեղ ենթասկոուպներ չկան',
    recursive: 'Ներառել ժառանգներին',
    collapse: 'Ծալել սկոուպների պանելը',
    openPicker: 'Ուսումնասիրել սկոուպները',
    up: 'Մեկ մակարդակ վերև',
    countTooltip: '{direct}՝ այս սկոուպում · {total}՝ ժառանգների հետ'
  },
  search: {
    tooltip: 'Որոնում (⌘K)',
    placeholder: 'Որոնեք VM-ներ, ցանցեր, պահոցներ…',
    empty: 'Համընկնումներ չկան',

    // Command palette ռաունդ (#221, վավերացվել է 2026-08-06). խմբերի
    // վերնագրերը, explorer-ի հաշվառումից դուրս մնացած տեսակները, ստեղների
    // բառարանը և «Գործողություններ» խմբի բայերը:
    groups: {
      recent: 'Վերջինները',
      shortcuts: 'Դյուրանցումներ',
      actions: 'Գործողություններ',
      goTo: 'Անցնել'
    },
    kind: {
      catalog: 'Կատալոգ',
      scope: 'Սկոուպ',
      node: 'Հանգույց'
    },
    footer: {
      navigate: 'նավարկել',
      open: 'բացել',
      close: 'փակել'
    },
    actions: {
      createVm: 'Ստեղծել VM…',
      uploadIso: 'Վերբեռնել ISO…',
      clusterSettings: 'Կլաստերի կարգավորումներ',
      consoleOf: 'Անցնել {name}-ի կոնսոլին'
    }
  },
  stub: {
    containersSummary: 'Հավելվածներ և համակարգային կոնտեյներներ (CT)՝ իրենց OCI պատկերներով, ռեգիստրներով ու ձևանմուշներով — կառավարվում են ձեր VM-ների կողքին։',
    sectionSummary_vms: 'Վիրտուալ մեքենաներ և նրանց ձևանմուշները — կենսական ցիկլ, սնապշոթներ, միգրացիա և կոնսոլներ։',
    sectionSummary_storages: 'Պահոցները, որտեղ ապրում են VM-ների սկավառակները, պատկերները և մետատվյալները։',
    sectionSummary_catalogs: 'Կլաստերի ֆայլային արտեֆակտների տունը. ISO պատկերներ, CT և VM ձևանմուշներ և OCI արխիվներ՝ կազմակերպված կատալոգներում։',
    sectionSummary_overlay: 'VXLAN օվերլեյ ցանցեր կլաստերի հանգույցների միջև։',
    sectionSummary_fabric: 'Ֆիզիկական ցանցի գույքացուցակը — կոմուտատորներ, պորտեր, LAGG-եր և տրամաբանական ցանցեր։',
    sectionSummary_ipam: 'Ֆաբրիկայի և օվերլեյ ցանցերից բխող հասցեավորումը. ով է պահում յուրաքանչյուր հասցե։',
    sectionSummary_services: 'Ցանցի ռեգիստրից ստացվող DHCP և DNS սերվերներ։',
    sectionSummary_ceph: 'Կառավարվող Ceph կլաստերներ TVirt հանգույցների վրա։',
    sectionSummary_hci: 'Հիպերկոնվերգենտ պահոցային տեխնոլոգիաները TVirt հանգույցների վրա։',
    sectionSummary_cluster: 'Հանգույցներ, անդամություն և ամբողջ կլաստերի կարգավորումներ։',
    containers: 'Համակարգային կոնտեյներները ճանապարհային քարտեզում են — այս բաժինը կհյուրընկալի դրանք։',
    containersApps: 'Կոնտեյներացված հավելվածները ճանապարհային քարտեզում են — այս տարածքը կհյուրընկալի դրանք։',
    containersPods: 'Pod-երը խմբավորում են ցանց և ծավալներ կիսող կոնտեյներներ — օրինակները հավելվածներն են:',
    containersCt: 'Համակարգային կոնտեյներները (CT) ճանապարհային քարտեզում են — այս տարածքը կհյուրընկալի դրանք։',
    multiscsi: 'TVStor MultiSCSI-ը ճանապարհային քարտեզում է — այս տարածքը կհյուրընկալի այն։',
    clusterFederation: 'TVirt կլաստերների միջև ֆեդերացիան ճանապարհային քարտեզում է — այս տարածքը կհյուրընկալի այն։',
    containersOciImages: 'OCI պատկերները ճանապարհային քարտեզում են — այս տարածքը կհյուրընկալի դրանք։',
    containersOciRegistries: 'OCI ռեգիստրները ճանապարհային քարտեզում են — այս տարածքը կհյուրընկալի դրանք։',
    containersCtTemplates: 'CT ձևանմուշները ճանապարհային քարտեզում են — այս տարածքը կհյուրընկալի դրանք։',
    importVms: 'Այստեղ կհայտնվեն ESXi-ի և Proxmox-ի ներմուծիչները. հյուր համակարգերի փոխարկում և զանգվածային միգրացիա դեպի TVirt։',
    backup: 'Ինտեգրված կրկնօրինակումը գալիս է 6.2-ի հետ. content-addressed դեդուպլիկացված շտեմարաններ, CBT ինկրեմենտալներ, անփոփոխելիության պատուհաններ և շտեմարանից շտեմարան ռեպլիկացիա։',
    monitoring: 'Ամբողջ կլաստերի մրցակցության վահանակները (cpu.ready, PSI ճնշում, ներկառուցված ահազանգեր) շուտով կլինեն — այսօր նույն մետրիկաներն ապրում են յուրաքանչյուր VM-ի մանրամասներում։'
  },
  home: {
    welcome: 'Դուք մուտք եք գործել որպես՝ {name}',
    subtitle: 'Ահա ձեր TVirt կլաստերը մի հայացքով։',
    loadError: 'Չհաջողվեց բեռնել ընդհանուր պատկերը — TVirt բեքենդը հասանելի՞ է',
    health: {
      ok: 'Ամեն ինչ կարգին է',
      warning: 'Ուշադրություն',
      critical: 'Կրիտիկական խնդիրներ'
    },
    reason: {
      'node-down': '{subject}-ն անջատված է',
      'node-stale': '{subject}-ը որոշ ժամանակ է՝ չի արձագանքում',
      'node-maintenance': '{subject}-ը սպասարկման մեջ է',
      'tasks-failed': {
        one: '{n} ձախողված առաջադրանք վերջին 24 ժամում',
        other: '{n} ձախողված առաջադրանք վերջին 24 ժամում'
      },
      'storage-degraded': '{subject} պահոցը դեգրադացված է',
      'storage-error': '{subject} պահոցը սխալի մեջ է',
      'ceph-warning': 'Ceph {subject}՝ HEALTH_WARN',
      'ceph-error': 'Ceph {subject}՝ HEALTH_ERR',
      'store-unreachable': 'կլաստերի կոնֆիգուրացիայի պահոցն անհասանելի է',
      'license-absent': 'լիցենզիա չկա — նոր VM-ները չեն կարող գործարկվել',
      'license-expired': 'լիցենզիայի ժամկետն անցել է — նոր VM-ները չեն կարող գործարկվել',
      'license-exceeded': 'լիցենզիայի սահմանը գերազանցված է — նոր VM-ները չեն կարող գործարկվել',
      'failover-reserve-eroded': 'վթարային փոխարկման պահուստը գրեթե սպառված է',
      'failover-reserve-exhausted': 'վթարային փոխարկման պահուստը սպառված է — նոր VM-ները չեն կարող գործարկվել',

      'oci-cache-nearly-full': 'OCI քեշը գրեթե լցված է {subject}-ում — digest-ները դուրս են մղվում ձեռքով',
      'oci-cache-full': 'OCI քեշը լցված է {subject}-ում — ոչ մի pull չի հաջողվի, մինչև digest-ներ դուրս չմղվեն',
      'config-replica-empty': '{subject}-ի կոնֆիգուրացիայի կրկնօրինակը ԴԱՏԱՐԿ է — հանգույցը կլաստերի կոնֆիգուրացիա չունի, մինչև կրկնօրինակումը հաջողվի',
      'config-replica-stalled': '{subject}-ի կոնֆիգուրացիայի կրկնօրինակումը կանգնել է — տեղական պատճենը հետ է մնում կլաստերի կոնֆիգուրացիայից'
    },
    staleChip: 'Տվյալները թարմ չեն',
    staleAsOf: 'վերջին ռեպլիկան՝ {time}',
    zone: {
      nodes: 'Հանգույցներ',
      failoverReserve: 'Վթարային փոխարկման պահուստ',
      capacity: 'Տարողություն',
      workload: 'Ծանրաբեռնվածություն',
      protection: 'Պաշտպանություն',
      activity: 'Վերջին ակտիվությունը'
    },

    // Վթարային փոխարկման պահուստի գոտին (admission control N+1, task #133b):
    reserve: {
      state: {
        ok: 'Պահուստն ամբողջական է',
        eroded: 'Պահուստը գրեթե սպառված է',
        exhausted: 'Պահուստը սպառված է',
        unknown: 'Պահուստն անհայտ է'
      },
      tolerate: {
        one: 'դիմանում է {n} հանգույցի կորստին',
        other: 'դիմանում է {n} հանգույցի կորստին'
      },
      usedOf: '{used} / {allowed} GiB օգտագործման մեջ',
      keepFree: '{n} GiB պահված է ազատ՝ վթարային փոխարկման համար',
      expendable: 'որից {n}-ը կարելի է զոհել շահագործման ընթացքում',
      headroom: 'դեռ կարելի է գործարկել {n} GiB',
      short: 'պահուստին պակասում է {n} GiB — նոր VM-ները չեն կարող գործարկվել',

      // Հսկա էջեր ըստ չափի (վավերացվել է 2026-08-04) — «պիտակ՝ {n}» ձևը
      // միտումնավոր է. ոչ մի լեզու չպիտի հոլովի փոփոխական թվից հետո:
      hp: {
        usedOf: '{size} չափի էջեր — օգտագործման մեջ՝ {used} / {allowed}',
        keepFree: 'պահված են ազատ վթարային փոխարկման համար՝ {keep}',
        headroom: 'դեռ գործարկելի՝ {n}',
        short: 'պահուստին պակասում են՝ {n} — հսկա էջերով նոր VM-ները չեն կարող գործարկվել'
      },
      worstCase: 'վատագույն դեպք՝ {nodes}',
      unavailable: '{node}՝ {reason}',
      unknown: 'Ոչ մի հանգույց դեռ չի հայտնել իր հիշողությունը — պահուստը հնարավոր չէ հաշվել, և ոչ մի գործարկում չի մերժվում։',
      reason: {
        attestedDown: 'հաստատված անջատված',
        maintenance: 'սպասարկման մեջ',
        unreachable: 'անհասանելի',
        capacityUnknown: 'հիշողությունը հայտնված չէ'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} միջուկ / {threads} հոսք',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} ակտիվ VM',
        other: '{n} ակտիվ VM'
      },
      activeVmsUnknown: 'ակտիվ VM-ների թիվն անհայտ է',
      lastSeen: 'երևացել է {time}',
      neverSeen: 'երբեք չի երևացել',
      down: 'Անջատված',
      maintenance: 'Սպասարկում',
      stale: 'Անհասանելի'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB տրամադրված',
      reserve: 'պահուստ՝ {n} GiB',
      unobserved: 'տարողությունը դեռ դիտարկված չէ',
      empty: 'Դեռ պահոց չկա'
    },
    workload: {
      vms: 'Վիրտուալ մեքենաներ',
      apps: 'Հավելվածներ',
      services: 'Ցանցային ծառայություններ',
      empty: 'Դեռ ոչինչ չկա',
      phasesUnknown: 'ըստ փուլերի բաշխումն անհասանելի է'
    },
    protection: {
      none: 'Կրկնօրինակման նպատակակետ դեռ կարգավորված չէ — պաշտպանեք ձեր կոնֆիգուրացիան։',
      configure: 'Կարգավորել checkpoint-ները',
      noRuns: 'Դեռ ոչ մի checkpoint չի ստեղծվել։',
      last: 'Վերջին checkpoint-ը',
      onTarget: '{target}-ի վրա',
      viewAll: 'Checkpoint-ներ'
    },
    activity: {
      empty: 'Վերջին ակտիվություն չկա',
      failed24: {
        one: '{n} ձախողված՝ 24 ժամում',
        other: '{n} ձախողված՝ 24 ժամում'
      },
      viewAll: 'Տեսնել բոլոր առաջադրանքները'
    }
  },
  notes: {
    title: 'Նշումներ',
    tabEdit: 'Խմբագրել',
    tabPreview: 'Նախադիտում',
    placeholder: 'Օպերատորի ազատ նշումներ — Markdown-ը ցուցադրվում է նախադիտման մեջ',
    empty: 'Նշումներ չկան',
    tooLarge: 'Նշումները գերազանցում են 64 KiB սահմանը',
    saveError: 'Չհաջողվեց պահպանել նշումները'
  },
  common: {

    // «Ազնիվ սխալների» ռաունդ (2026-08-03). 200 պատասխանը, որն այս կլիենտը
    // չի կարող կարդալ, ցանցի խափանում ՉԷ — բեքենդին մեղադրելը օպերատորին
    // ուղարկում է սարքին աշխատող ծառայություն զննելու (bug hunt #157, U1):
    contractError: 'Բեքենդի պատասխանը պարունակում է այս ինտերֆեյսին անծանոթ արժեք՝ {field}={value} — թարմացրեք վեբ ինտերֆեյսը բեքենդի տարբերակին։',
    contractErrorItems: 'Այս ցուցակի {count} օբյեկտ այս ինտերֆեյսի համար ընթեռնելի չեն ({field}={value}) և չեն ցուցադրվում։',
    staleHint: 'Կոնֆիգուրացիայի պահոցն անհասանելի է — սա այս հանգույցի կոնֆիգուրացիայի ռեպլիկան է. նավատորմի վիճակն անհայտ է։',
    staleStateAge: 'վիճակը՝ {time}',
    staleStateNever: 'վիճակը երբեք չի ստացվել պահոցից. տեսնում եք միայն այս հանգույցի սեփական դիտարկումները',
    staleStateTooltip: 'Կլաստերի պահոցն անհասանելի է. դիտարկվող վիճակը (փուլ, հանգույց, գործակալ) գալիս է այս հանգույցի վիճակի ռեպլիկայից և վերաբերում է պահոցից վերջին հաջող ընթերցմանը — այն կարող է հնացած լինել։',
    noPermission: 'Այս գործողության համար թույլտվություն չունեք',

    // Սպառված սպասման բյուջեն արդյունք ՉԷ (Luca 2026-08-06). կլիենտի
    // վայրկյանաչափը չափում է կլիենտի համբերությունը, ոչ թե սերվերի վիճակը —
    // ծանուցումն ասում է «դեռ ընթացքի մեջ է», երբեք «չհաջողվեց»:
    actionStillRunning: 'Գործողությունը դեռ ընթացքի մեջ է՝ արդյունքը դեռ հայտնի չէ',
    staleWrite: 'Մեկ ուրիշը փոխել է այս օբյեկտը, քանի դեռ դուք խմբագրում էիք այն — ոչինչ չի գրվել: Վերաբեռնեք և կրկնեք փոփոխությունը թարմ վիճակի վրա:',
    staleReload: 'Վերաբեռնել',
    preview: 'Նախադիտում',
    previewTitle: 'Արդյունքի նախադիտում',
    previewNothingWritten: 'Մոդելավորված է սերվերի վրա — ոչինչ չի գրվել։',
    previewChanged: 'Ընդգծված են այն արժեքները, որոնք կփոխվեին։'
  },
  context: {
    copySelection: 'Պատճենել նշված տեքստը'
  },
  crud: {
    create: 'Ստեղծել',
    viewDetails: 'Տեսնել մանրամասները',
    viewOrEdit: 'Տեսնել կամ խմբագրել',
    selected: 'ընտրված',
    viewUsingVms: 'Տեսնել այս ռեսուրսն օգտագործող VM-ները',
    clearSelection: 'Մաքրել ընտրությունը',
    deleteSelected: 'Ջնջել ընտրվածները',
    bulkConfirmBody: {
      one: 'Ջնջե՞լ ընտրված {count} տարրը։ Եթե պաշտպանված է, կնշվի և կպահվի։',
      other: 'Ջնջե՞լ ընտրված {count} տարրերը։ Պաշտպանվածները կնշվեն և կպահվեն։'
    },
    bulkDeleted: 'ջնջված',
    bulkRefused: 'մերժված',

    // Ռաունդ #156 (ստանդարտ երկխոսություն). ընդհանուր մետատվյալների տողերը,
    // որոնցով փակվում է ամեն մանրամասների երկխոսություն, և կողպեքի պատկերակի
    // ընդհանուր անփոփոխելիության հուշումները:
    fieldId: 'ID',
    createdAt: 'Ստեղծվել է',
    updatedAt: 'Թարմացվել է',
    immutableField: 'Ամրագրվում է ստեղծման պահին — contract-ը թույլ չի տալիս փոխել այն',
    immutableScope: 'Սկոուպը նշանակվում է ստեղծման պահին. որոշ ռեսուրսներ տեղափոխվում են հատուկ գործողությամբ',
    observedField: 'Դիտարկված վիճակ — հայտնում է պլատֆորմը, խմբագրելի չէ'
  }
}
